import React from 'react';

import styled from 'styled-components';

import { truncateHoursString } from '../../activities/utils';
import {
  StyledMobileBoxItem,
  StyledMobileBoxItemRow,
  StyledMobileBoxLabel,
} from '../../utils/Styles/DataBoxStyles';
import DollarOutput from '../../utils/DollarOutput';
import { BookingOption } from '../../../types/Activity';

const StyledTitle = styled(StyledMobileBoxItemRow)`
  font-size: 18px;
  color: #b6266b;
  max-width: 100%;
`;

const StyledRow = styled(StyledMobileBoxItemRow)`
  font-weight: 400;
  max-width: 100%;

  *:first-child {
    margin-left: 0;
  }
  * {
    margin-left: 10px;
  }
`;

type Props<T> = {
  item: T;
  uiElements: Record<string, React.ComponentType<T>>;
};

const getPricingModelIcon = (pricingModel: BookingOption['pricingModel']) =>
  pricingModel === 'person' ? 'fa-user' : 'fa-users';
const formatDuration = (duration: BookingOption['duration']) =>
  duration ? `(${duration}) minutes` : '';

const EditOrderBookingOptionListItem = <T extends BookingOption>(
  props: Props<T>
) => {
  const {
    action: ActionElement,
    attendees: AttendeesElement,
  } = props.uiElements;

  return (
    <StyledMobileBoxItem>
      <StyledMobileBoxLabel>
        <ActionElement {...props.item} />
      </StyledMobileBoxLabel>
      <StyledTitle>{props.item.title}</StyledTitle>
      <StyledRow>
        <i className={`fas ${getPricingModelIcon(props.item.pricingModel)}`} />
        <DollarOutput value={props.item.price} />
        <span>{formatDuration(props.item.duration)}</span>
      </StyledRow>
      {AttendeesElement && <AttendeesElement {...props.item} />}
      <StyledRow dangerouslySetInnerHTML={{ __html: props.item.description }} />
      <StyledRow>{truncateHoursString(props.item.hours)}</StyledRow>
    </StyledMobileBoxItem>
  );
};

export default EditOrderBookingOptionListItem;
